export enum BackgroundColor {
  White,
  Grey,
}
